import { connect } from 'react-redux';
import OnboardingBilling from '../components/OnboardingBilling';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import { BillingSelectors } from '../../../Redux/modules/billing/selectors';
import { OrganizationSelectors } from '../../../Redux/modules/organization/selectors';
import { displayNotification } from '../../../Utils/GenericUtils';
import { BillingActions } from '../../../Redux/modules/billing/actions';
import { OrganizationActions } from '../../../Redux/modules/organization/actions';

const mapStateToProps = (state) => ({
  user: AppSelectors.userSelector(state),
  tracking: AppSelectors.trackingSelector(state),
  signupPaymentMethod: AppSelectors.organizationSelector(state).signupPaymentMethod,
  paymentMethod: BillingSelectors.billingSelector(state),

  organization: OrganizationSelectors.organizationDetailsSelector(state),
  isUpdatingOrganization: OrganizationSelectors.editingOrganizationLoaderSelector(state),
  isFetchingOrganization: OrganizationSelectors.isLoadingOrganizationSelector(state),
  stripeTokenStatus: BillingSelectors.stripeTokenSelector(state),

  isOnBoardingCreditCard: BillingSelectors.onBoardingCardLoadingSelector(state),
});

const mapActionCreators = {
  displayNotification,
  fetchOrganization: OrganizationActions.organizationDetailsFetch,
  fetchPaymentMethod: BillingActions.billingInfoFetch,

  createCreditCard: BillingActions.addCreditCardOnBoarding,
  createStripeTokenInProgress: BillingActions.connectingToStripe,
  createStripeTokenFailed: BillingActions.connectingToStripeFailed,

  updateOrganizationDetails: OrganizationActions.setDetailsOnboarding,
};

export default connect(mapStateToProps, mapActionCreators)(OnboardingBilling);
